import Typography from '@mui/material/Typography';
import { Markdown } from '@repo/ui/src/components/Markdown';
import Accordion, { AccordionItem } from '@repo/ui/src/components/Accordion';

interface Props {
  title: string;
  markdown: string;
  disclaimerText: string;
}

const ExpandableContentWithMarkdown = ({ title, markdown, disclaimerText }: Props) => {
  return (
    <Accordion allowZeroExpanded>
      <AccordionItem key={`base_accordion_${title}`} heading={title}>
        <div className="tw-my-6">
          <Markdown bodySize="large">{markdown}</Markdown>
        </div>
        <Typography className="tw-text-warm-500">{disclaimerText}</Typography>
      </AccordionItem>
    </Accordion>
  );
};

export default ExpandableContentWithMarkdown;
